import React, { FC, useContext, useState, useEffect } from 'react';
import produce from 'immer';
import set from 'lodash/set';

import BaseNodeSelector from './BaseNodeSelector';
import FormContext from 'src/presentation/contexts/FormContext';
import useCreateNewNode from 'src/presentation/components/pages/ivr/hooks/useCreateNewNode';
import { CREATE_NEW_NODE } from 'src/presentation/components/pages/ivr/constants/ivrConstants';

type DropdownOptions = { label: string; value: string };

type NodeSelectorProps = {
  attr: string;
  onChange: Function;
  onSelectNode: Function;
  options: DropdownOptions[];
  stayOnParentNodeAfterCreation: boolean;
  otherProps?: any;
};

const NodeSelector: FC<NodeSelectorProps & any> = ({
  attr,
  onChange,
  onSelectNode,
  options,
  stayOnParentNodeAfterCreation,
  ...otherProps
}) => {
  const { errors, workingState, updateState, resetError, onBlur } = useContext(FormContext);
  const [nodeList, setNodeList] = useState<DropdownOptions[]>([]);

  useEffect(() => {
    setNodeList(options);
  }, [options, setNodeList]);

  const { limitNodeTypesTo } = otherProps;
  const { selectNodeTypeModal, setShowSelectNodeTypeModal } = useCreateNewNode({
    attr,
    nodeList,
    onBlur,
    onChange,
    onSelectNode,
    stayOnParentNodeAfterCreation,
    workingState,
    limitNodeTypesTo,
  });

  const onSelect = val => {
    resetError({ attr, errors });
    if (val === CREATE_NEW_NODE) {
      setShowSelectNodeTypeModal(true);
    } else if (onChange) {
      onChange(val);
    } else {
      updateState(set({}, attr, val));
      onBlur && onBlur({ currentState: produce(workingState, draftState => set(draftState, attr, val)) });
    }
  };

  return (
    <>
      <BaseNodeSelector
        attr={attr}
        onChange={onSelect}
        onSelectNode={onSelectNode}
        options={nodeList}
        {...otherProps}
      />
      {selectNodeTypeModal}
    </>
  );
};

export default NodeSelector;
